export default __webpack_public_path__ + "static/media/analytics-graph-all-toggle-off-image.7b02a897.svg";